var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "79px",
    height: "79px",
    viewBox: "-0.5 -0.5 79 79",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T12:21:46.743Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"nAiwU40p715JiX2R6FCz\" version=\"16.5.1\" type=\"device\"><diagram id=\"u4Q9mtqc-7ff_6t4GGxs\" name=\"Page-1\">jZRRb6MwDIB/DY+rGiilezxYe5u0SSd10+keMzAQNWAU0pXerz+nCS0UJl1L2/izHTtubC9Iqu6n4k35hhlIz19mnRc8eb4fbNb0bcDZAj9cWVAokVnEbmAv/oKDS0ePIoN2ZKgRpRbNGKZY15DqEeNK4WlslqMcR214AROwT7mc0t8i06WlGz+68WcQRdlHZutHq6l4b+xO0pY8w9MABVsvSBSitquqS0Ca2vV1sX67b7TXxBTU+n8cPvYfxfp9W78f8ocoed7+eWX8wbe7fHF5dAd2yepzX4H2ADo1R1l6QdygqPWlpGFMD0VM7Cck08SQhR/OwDkWTSGbmtEPm4twD+dYNIVsamakPusxnGNROM343pvNeLM7b3qCGI9aihqS6+U1Nc6x1glKVJf6B/TemX80LhTPBIx0u3AVrR4HuiehaCOBNelrVOYKxrmQcuCTRCxgdEniVis8wECTX16kyXhbQubS+QKlBTXEK/8E+Qtb4bb/RK2xGhj8kKIwCo0NUe6klLICChCXupIkM3dC1+rM72V340xI3ja2HLnoTB4x9U5jlFVXmCmz4Kd2tVDQ4lGl8JKafGIS7WpsxatGipymT+yuOmUL3bc9xK6dSRMNsAKtzmTiHCLXy+e+2518uo2GaGNROZgKPeNuGBXXjW/9SgvXsr14Gw0X3WC+Btt/</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f54749-1-c7131f-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(199, 19, 31)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(245, 71, 73)",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 78 0 L 78 78 L 0 78 Z",
    fill: "url(#mx-gradient-f54749-1-c7131f-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.81 60.79 L 38.45 17.21 L 44.85 17.21 L 67.21 60.79 Z M 70.02 61.39 L 46.52 15.59 C 46.33 15.22 45.95 14.98 45.53 14.98 L 36.63 14.98 C 36.24 14.98 35.88 15.19 35.68 15.52 C 35.48 15.85 35.46 16.26 35.64 16.61 L 59.14 62.41 C 59.33 62.78 59.72 63.02 60.13 63.02 L 69.03 63.02 C 69.42 63.02 69.78 62.81 69.98 62.48 C 70.18 62.15 70.2 61.74 70.02 61.39 Z M 47.45 60.79 L 30.34 28.7 L 33.84 22.91 L 53.84 60.79 Z M 34.89 20.13 C 34.71 19.77 34.34 19.55 33.94 19.54 C 33.56 19.51 33.17 19.73 32.96 20.07 L 28.11 28.09 C 27.91 28.43 27.89 28.85 28.08 29.19 L 45.8 62.43 C 46 62.79 46.38 63.02 46.79 63.02 L 55.68 63.02 C 56.07 63.02 56.44 62.81 56.64 62.48 C 56.84 62.14 56.85 61.73 56.67 61.38 Z M 10.94 60.79 L 26.64 34.83 L 29.83 40.82 L 22.46 53.56 C 22.26 53.9 22.26 54.33 22.46 54.67 C 22.66 55.02 23.03 55.23 23.43 55.23 L 37.52 55.23 L 40.48 60.79 Z M 39.17 53.59 C 38.97 53.23 38.59 53 38.18 53 L 25.36 53 L 32.07 41.4 C 32.26 41.07 32.27 40.66 32.09 40.32 L 27.68 32.05 C 27.49 31.7 27.13 31.48 26.73 31.47 C 26.3 31.45 25.95 31.66 25.75 32 L 8.01 61.33 C 7.81 61.67 7.8 62.1 8 62.45 C 8.19 62.8 8.56 63.02 8.97 63.02 L 42.34 63.02 C 42.73 63.02 43.09 62.81 43.29 62.48 C 43.49 62.14 43.5 61.72 43.32 61.38 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplify);
export default __webpack_public_path__ + "static/media/Amplify.2fe2d51102f9dc8d77cb9eed477325c8.svg";
export { ForwardRef as ReactComponent };